import React from 'react'
import { useNormalizedPublishedTime } from '@libs/getNormalizedPublishedTime'
import {
  SearchArticles_searchArticles_articles,
  SearchArticles_searchArticles_articles_publisher,
} from '@apollo-types/SearchArticles'
import { trackSearchResultListEnterArticleEvent } from '@libs/eventTracking/search'
import { appendUrlSearchParams } from '@libs/url-utils'
import DesktopArticleCard from './DesktopArticleCard'
import MobileArticleCard from './MobileArticleCard'

interface ArticleCardProps {
  index?: number
  article?: SearchArticles_searchArticles_articles
  keyword?: string
  filter?: string
  sort?: string
}

export interface SearchArticle {
  publisher?: SearchArticles_searchArticles_articles_publisher | null
  title?: string | null
  id?: string | null
  articleImageUrl?: string | null
  articleUrl?: string | null
  publishedTime?: any | null
  plainTextContent?: string | null
  tags?: (string | null)[] | null
  hashTags?: (string | null)[] | null
}

export default function ArticleCard({ index, article, keyword, filter, sort }: ArticleCardProps) {
  const { url, publisher, publishedAt, coverImage, hashTags, title, id, plainTextContent, tags } =
    article
  const articleImageUrl = coverImage?.croppedUrl || '/images/articleCardImagePlaceholder.svg'
  const articleUrl = appendUrlSearchParams(url, {
    fromPage: { pageName: 'web-search', pageComponent: 'result-list' },
  })
  const publishedTime = useNormalizedPublishedTime(publishedAt)

  const formattedArticle = {
    publisher,
    title,
    id,
    articleImageUrl,
    articleUrl,
    publishedTime,
    plainTextContent,
    hashTags,
    tags,
  }

  // web-search.result-list.enter-article Event tracking
  const trackEnterEvent = () => {
    if (!id || !url || !keyword) return
    trackSearchResultListEnterArticleEvent({
      currentKeyword: keyword,
      toPageUrl: url,
      index,
      typeFilter: filter,
      sortFilter: sort,
    })
  }

  return (
    <div id={`article-${id}`}>
      <DesktopArticleCard
        article={formattedArticle}
        keyword={keyword}
        trackEnterEvent={trackEnterEvent}
        typeFilter={filter}
        sortFilter={sort}
      />
      <MobileArticleCard
        article={formattedArticle}
        keyword={keyword}
        trackEnterEvent={trackEnterEvent}
        typeFilter={filter}
        sortFilter={sort}
      />
    </div>
  )
}
